export default function(userOptions) {
  return {
    //Defaults
    viewBag: {},
    backOptionId: null, //give id of the "back" menu option for ESC key

    shouldRememberOptions: true, //Default to YES - remember things
    dontRememberOptionIds: [], //But don't allow remember-setting of these optionIds

    getFirstSelectedOptionOnActivation(availableOptionModels) {
      //Default to just use the first one!
      return availableOptionModels[0].id;
    },

    //Merge options
    ...userOptions,

    //Computed
    menuOptions: userOptions.getMenuOptions(),
    menuOptionsLayout: userOptions.getMenuOptionsLayout()
  };
}



// WEBPACK FOOTER //
// ./src/menu-engine/View.js